'use client';

import { Label } from '@/components/ui/label';
import { Minus, Plus } from 'lucide-react';
import { useState } from 'react';

export const mimNumber = (
  maxSize: number,
  maxBookingsAllowed: any,
  remainingSeats?: any,
) => {
  if (maxBookingsAllowed) {
    return Math.min(maxSize || 0, maxBookingsAllowed || 0, remainingSeats || 0);
  }
  return maxSize;
};

interface TProps {
  ticket: any;
  handleTicket: (ticket: any, quantity: number, action?: string) => void;
}

const Counter = ({ ticket, handleTicket }: TProps) => {
  const [count, setCount] = useState(1);

  const maxLimit = mimNumber(
    Number(ticket?.maxSeats),
    Number(ticket?.maxBookingsAllowed),
    Number(ticket?.remainingSeats),
  );

  const onDecrease = () => {
    const newCount = count - 1;

    if (newCount < 0) return;

    setCount(newCount);

    if (newCount === 0) {
      handleTicket(ticket, 0, 'remove');
    } else {
      handleTicket(ticket, newCount);
    }
  };

  const onIncrease = () => {
    if (count >= maxLimit) return;

    const newCount = count + 1;
    setCount(newCount);
    handleTicket(ticket, newCount);
  };

  return (
    <div className='flex items-center space-x-1 overflow-hidden rounded-lg border text-white'>
      <button
        aria-label='Decrease ticket quantity'
        className='bg-gray-100 hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50'
        onClick={onDecrease}
        disabled={count <= 0}
      >
        <Label className='cursor-pointer border-r p-2 text-black'>
          <Minus strokeWidth={3} size={16} />
        </Label>
      </button>
      <span className='rounded-sm px-3 py-1 text-base font-medium text-black'>
        {count}
      </span>
      <button
        aria-label='Increase ticket quantity'
        className='bg-gray-100 hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50'
        onClick={onIncrease}
        disabled={count >= maxLimit}
      >
        <Label className={`cursor-pointer border-l p-2 text-black`}>
          <Plus strokeWidth={3} size={16} />
        </Label>
      </button>
    </div>
  );
};

export default Counter;
